import * as d3 from 'd3'
export default {

  methods: {

    draw_Table() {

      let table = this.canvasForms
      .append('g')
      .attr('transform', `translate(${this.header.x}, ${this.table.y})`)

      let y = 0
      let half = this.table.lineHeight / 2
      this.rawData.forEach((d,i)=> {

        let dataGroup = table
        .append('g')
        .attr('id', `RFQ_${i}`)
        .attr('transform', `translate(${0}, ${y})`)
        .call(this.call_LINK, d, i)

        dataGroup
        .append('rect')
        .attr('id', `RFQ_BG_${i}`)
        .attr('x', 0).attr('y', -half)
        .attr('width', this.table.width + this.timeline.length)
        .attr('height', this.table.lineHeight).attr('fill', '#F4F5F5').attr('opacity', 0)

        this.columns.forEach((col,c)=> {
          dataGroup
          .append('rect')
          .attr('x', .5).attr('y', -half+2.5)
          .attr('width', 5).attr('height', this.table.lineHeight-5)
          .attr('fill', this.legends.find(f=> f.code == d.STATUS).color).attr('opacity', .1)

          dataGroup
          .append('text')
          .attr('x', col.x).attr('y', 10*0.35)
          .attr('fill', d[col.code] == 0 ? '#bcbcbc' : '#333')
          .attr('font-size', 10).attr('font-weight', c<2 ? 500 : 400)
          .attr('text-anchor', col.align)
          .text(d[col.code])
        })

        table
        .append('line')
        .attr('x1', 0).attr('y1', y + half).attr('x2', this.table.width + this.timeline.length).attr('y2', y + half)
        .attr('stroke', '#bcbcbc').attr('stroke-width', .5).attr('opacity', .5)

        y = y + this.table.lineHeight
      })

      table
      .append('line')
      .attr('x1', 0).attr('y1', y-15).attr('x2', this.table.width + this.timeline.length).attr('y2', y-15)
      .attr('stroke', '#757575').attr('stroke-width', .5)
    },

    
  }
}